import web from "../web";

class MatieresService {
    index(token){
        return web.get("/api/matieres", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/matieres", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/matieres/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/matieres/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/matieres/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new MatieresService()